<template>
  <div>
    <span v-if="val">{{ BusinessOpportunityTypeMap[val] }}</span>
    <el-select
      v-else
      :value="value"
      size="small"
      clearable
      @change="handleChange"
      placeholder="请选择"
      style="width: 100%"
      :popper-append-to-body="true"
    >
      <el-option key="0" :value="0" label="请选择" disabled></el-option>
      <el-option
        v-for="(k, v) in BusinessOpportunityTypeMap"
        :key="v"
        :label="k"
        :value="parseInt(v)"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { BusinessOpportunityTypeMap } from '@/config/global'

export default {
  props: {
    value: '',
    val: '',
  },
  data() {
    return {
      lists: [],
      BusinessOpportunityTypeMap,
    }
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e)
    },
  },
}
</script>